import { Input } from 'ohzi-core';
import { Vector2 } from 'three';
import Idle from './Idle';

export default class WaitingForScroll
{
  constructor(target_wall)
  {
    this.target_wall = target_wall;
    this.last_NDC = new Vector2();
  }

  on_enter(wall_clicker)
  {
    this.target_wall.show_info();
  }

  update(wall_clicker)
  {
    if (Input.left_mouse_button_pressed)
    {
      this.last_NDC.copy(Input.NDC);
    }

    if (Math.abs(Input.wheel_delta) > 0 ||
    (Input.left_mouse_button_down && Math.abs(Input.NDC.clone().sub(this.last_NDC).y) > 0) ||
    (Input.mouse_clicked() && !wall_clicker.walls_manager.raycasted_wall))
    {
      wall_clicker.set_state(new Idle());
    }

    this.last_NDC.copy(Input.NDC);
  }

  on_exit(wall_clicker)
  {
    this.target_wall.hide_info();
    this.target_wall.is_opened = false;
    wall_clicker.walls_manager.is_wall_opened = false;
  }
}
